import 'css-chunksrc/client/scenes/resourceDetailsConfiguration/form/styles.scss';export default {
  "form": "_form_wjbxc_1",
  "group": "_group_wjbxc_5",
  "row": "_row_wjbxc_9",
  "label": "_label_wjbxc_19",
  "description": "_description_wjbxc_24",
  "roleSelection": "_roleSelection_wjbxc_28"
};